"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurstSymbol = 'Ƀ';
exports.BurstPlanckSymbol = 'ƀ';
exports.FeeQuantPlanck = 735000;
exports.OneBurstPlanck = 100000000;
//# sourceMappingURL=constants.js.map